<div class="pt-5 pb-70">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-6 mb-4" *ngIf="detail1">
                <div class="p-4 shadow-sm border-1 rounded-2 bg-white h-100">
                    <div class="icon col-4"><i class="flaticon-megaphone"></i></div>
                    <div class="col-8">
                        <h3>{{title1}} - {{subtitle1}}</h3>
                        <p>{{detail1}}</p>
                    </div>
                </div>
            </div>
            <div class="col-md-6 mb-4" *ngIf="title2">
                <div class="p-4 shadow-sm border-1 rounded-2 bg-white h-100">
                    <div class="icon col-4"> <i class="flaticon-keywords"></i> </div>
                    <div class="col-8">
                        <h3> {{title2}} - {{subtitle2}}</h3>
                        <p>{{detail2}}</p>
                    </div>
                </div>
            </div>
            <div class="col-md-6 mb-4" *ngIf="title3">
                <div class="p-4 shadow-sm border-1 rounded-2 bg-white h-100">
                    <div class="icon col-4"> <i class="flaticon-content-management"></i> </div>
                    <div class="col-8">
                        <h3> {{title3}} - {{subtitle3}}</h3>
                        <p>{{detail3}}</p>
                    </div>
                </div>
            </div>
            <div class="col-md-6 mb-4">
                <div class="p-4 shadow-sm border-1 rounded-2 bg-white h-100">
                    <div class="icon col-4"> <i class="flaticon-competitor"></i> </div>
                    <div class="col-8">
                        <h3> {{title4}} - {{subtitle4}}</h3>
                        <p>{{detail4}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>